export enum AdvisoryProjectModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
